<template>
  <div
    v-clickoutside="close"
    :class="['calender', { autocomplete__open: popVisible }]"
  >
    <div @click="openPop" :style="{}" :class="['input-container']">
      <!-- 前置内容 -->
      <span class="input__prefix">
        <slot name="prefix"> </slot>
      </span>
      <input
        readonly="readonly"
        @focus="handleFocus"
        v-bind="[$props, $attrs]"
        class="by-input__inner"
        v-model="dateVal"
      />
      <!-- 自定义后置 -->
      <div class="input__custom__suffix" v-if="$slots.custom_suffix">
        <slot name="custom_suffix"> </slot>
      </div>
    </div>
    <transition name="el-zoom-in-top">
      <div v-show="popVisible" class="calender-container">
        <header>
          <!-- <div> -->
          <i @click="turnPage('preYear')" class="pre-year"></i>
          <!-- </div>
        <div > -->
          <i @click="turnPage('preMouth')" class="pre-month"></i>
          <!-- </div> -->
          <span @click="turnPage('')" class="cur-mouth">{{ headerTitle }}</span>
          <i class="next-month" @click="turnPage('nextMonth')"></i>
          <i class="next-year" @click="turnPage('nextYear')"></i>
        </header>
        <ul class="weeks">
          <li v-for="w in weeks">{{ w }}</li>
        </ul>
        <div class="day-box">
          <ul v-for="row in dayArr">
            <li
              @click="changeDate(item)"
              :style="{
                color: !item.isCurMonth || item.isBefore ? '#ccc' : ''
              }"
              :class="[
                { day_isSelect: item.isSelect },
                { not__optional: !item.isCurMonth || item.isBefore }
              ]"
              v-for="item in row"
            >
              <span> {{ item.text }}</span>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const MOUTH_MAP = {
  1: "January ",
  2: "February",
  3: "March",
  4: "April ",
  5: "May ",
  6: "June",
  7: "July ",
  8: "August",
  9: "Septembe",
  10: "October ",
  11: "November",
  12: "December"
};
export default {
  inheritAttrs: false,
  props: {
    value: {} //输入框的值
  },
  computed: {
    //输入框
    dateVal() {
      this.dayArr = this.getRenderData(this.value);
      const arr = this.value.split("-");
      return `${arr[2]}th ${MOUTH_MAP[arr[1]]},${arr[0]}`;
    },
    //标题
    headerTitle() {
      const arr = this.value.split("-");
      return `${this.yearVal} ${MOUTH_MAP[this.mouthVal]}`;
    },
    yearVal: {
      get() {
        return this.dateTitle.split("-")[0];
      },
      set(v) {
        let arr = this.dateTitle.split("-");
        arr[0] = v;
        const str = arr.join("-");
        this.dateTitle = str;
      }
    },
    mouthVal: {
      get() {
        return this.dateTitle.split("-")[1];
      },
      set(v) {
        let arr = this.dateTitle.split("-");
        arr[1] = v;
        const str = arr.join("-");
        this.dateTitle = str;
      }
    },
    dayVal() {
      return this.value.split("-")[2];
    }
  },
  data() {
    return {
      popVisible: false,
      weeks: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayArr: [],
      dateTitle: this.value //标题
    };
  },
  watch: {
    value(val) {
      this.dateTitle = val;
    }
  },
  mounted() {
    this.dayArr = this.getRenderData(this.value);
    // this.dayArr = this.getRenderData('2021-8-8');
  },
  // watch(){
  //   value:{

  //   }
  // },
  methods: {
    //改变输入框的值
    changeDate(item) {
      if (!item.isCurMonth || item.isBefore) return;
      this.$emit("input", `${this.dateTitle.replace(/\d+$/, item.text)}`);
      this.close();
    },
    // 翻页
    turnPage(method) {
      const strategy = {
        preYear() {
          this.yearVal = this.yearVal - 1 + "";
          this.dayArr = this.getRenderData(
            `${this.yearVal}-${this.mouthVal}-${this.dayVal}`
          );
        },
        preMouth() {
          if (this.mouthVal == 1) {
            this.mouthVal = 12;
            this.yearVal--;
          } else {
            this.mouthVal--;
          }
          this.dayArr = this.getRenderData(
            `${this.yearVal}-${this.mouthVal}-${this.dayVal}`
          );
        },
        nextMonth() {
          if (this.mouthVal == 12) {
            this.mouthVal = 1;
            this.yearVal++;
          } else {
            this.mouthVal++;
          }
          this.dayArr = this.getRenderData(
            `${this.yearVal}-${this.mouthVal}-${this.dayVal}`
          );
        },
        nextYear() {
          this.yearVal = this.yearVal - 0 + 1 + "";
          this.dayArr = this.getRenderData(
            `${this.yearVal}-${this.mouthVal}-${this.dayVal}`
          );
        }
      };
      strategy[method].call(this);
    },
    //获取渲染数据
    getRenderData(timeStr) {
      let dayStr = timeStr.split("-")[2];
      let res = [];
      //获取当月天数和第一天是星期几
      function getDatNums(str) {
        const arr = str.split("-");
        const year = arr[0],
          mouth = arr[1];
        return [
          new Date(year, mouth, 0).getDate(),
          new Date(year, mouth - 1, 0).getDay()
        ];
      }
      // 获取前一个月天数
      function getPreDays(str) {
        const arr = str.split("-");
        // 获取上个月一号的日期
        const date = new Date(arr[0], arr[1] - 1, 1);
        return new Date(date.getFullYear(), date.getMonth(), 0).getDate(); //天数
      }
      let preMouthDays = getPreDays(timeStr);
      const [dayNum, firstWhat] = getDatNums(timeStr);
      // debugger
      let n = 1,
        nextMouthDay = 1;
      for (let i = 0; i < 6; i++) {
        const temp = [];

        for (let j = 0; j < 7; j++) {
          if (i === 0) {
            if (j < firstWhat) {
              temp.unshift({
                isSelect: false,
                isCurMonth: false,
                text: preMouthDays--
              });
            } else {
              temp.push({
                isSelect: dayStr == n  ? true : false,
                isCurMonth: true,
                text: n++
              });
            }
          } else {
            let t = n++;
            if (t > dayNum) {
              temp.push({
                isSelect: false,
                isCurMonth: false,
                text: nextMouthDay++
              });
            } else {
              temp.push({
                isSelect: dayStr == n - 1 ? true : false,
                isCurMonth: true,
                text: t
              });
            }
          }
        }
        res.push(temp);
      }
      res = reduceBefore(res);
      //筛选  去除掉过去的时间
      function reduceBefore(arrs) {
        const arr = timeStr.split("-");
        const year = arr[0],
          mouth = arr[1],
          day = arr[2],
          now = new Date(),
          nowYear = now.getFullYear(),
          nowMonth = now.getMonth(),
          nowDay = now.getDate();
        for (let i = 0; i < arrs.length; i++) {
          for (let j = 0; j < arrs[i].length; j++) {
            if (year < nowYear) {
              arrs[i][j]["isBefore"] = true;
            } else if (year > nowYear) {
              arrs[i][j]["isBefore"] = false;
            } else {
              if (mouth < nowMonth + 1) {
                arrs[i][j]["isBefore"] = true;
              } else if (mouth > nowMonth + 1) {
                arrs[i][j]["isBefore"] = false;
              } else {
                const ddd = arrs[i][j].text;
                // debugger
                if (ddd < nowDay) {
                  arrs[i][j]["isBefore"] = true;
                } else {
                  arrs[i][j]["isBefore"] = false;
                }
              }
            }
          }
        }
        return arrs;
      }
      return res;
    },
    handleFocus(e) {
      // this.popVisible = true;
    },
    openPop() {
      this.popVisible = true;
    },
    //关闭弹框
    close() {
      this.popVisible = false;
    }
    //筛选数据
  }
};
</script>

<style lang="scss" scoped>
@mixin commom($type) {
  content: "";
  display: inline-block;
  height: 9px;
  width: 9px;
  border-bottom: 1px solid #fff;
  @if $type==left {
    transform: rotate(-45deg);
  } @else {
    transform: rotate(135deg);
  }
  border-right: 1px solid #fff;
}
@mixin pageIcon($type, $num) {
  cursor: pointer;

  &::before {
    @include commom($type);
  }

  @if $num==2 {
    &::after {
      @include commom($type);
    }
  }
}

.calender {
  height: 60px;
  box-sizing: border-box;
  color: #fff;
  font-size: 15px;
  position: relative;
  .input-container {
    cursor: pointer;
    font-size: 15px;
    padding: 0 20px;
    position: relative;
    height: 100%;
    background-color: #577ec7;
    border-radius: 30px;
    display: flex;
    overflow: hidden;
    box-sizing: border-box;
    .input__prefix {
      color: #fff;
      // height:100%;
      text-align: center;
      line-height: 60px;
      & > * {
        margin-right: 10px;
      }
    }
  }
  .by-input__inner {
    cursor: pointer;
    height: 100%;
    background-color: #577ec7;
    border: none;
    box-sizing: border-box;
    color: #fff;
    display: inline-block;
    font-size: inherit;
    line-height: 100%;
    outline: none;
    flex: 1;
    &:focus {
      // border-color: red !important;
      outline: none !important;
    }
    @include inputPlaceholder(#abbee3);
  }

  .input__custom__suffix {
    padding: 10px;
    line-height: 40px;
  }
}
.calender-container {
  text-align: center;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 1;
  background: #577ec7;
  padding: 0 20px 0px;
  box-sizing: border-box;
  header {
    height: 55px;
    display: flex;
    justify-content: space-between;
    line-height: 55px;
    .cur-mouth {
      flex: 1;
      text-align: center;
    }
    .pre-year {
      text-align: left;
      width: 20px;
      @include pageIcon(right, 2);
    }
    .pre-month {
      width: 30px;
      margin-left: 20px;
      @include pageIcon(right, 1);
    }

    .next-year {
      text-align: left;
      width: 20px;
      @include pageIcon(left, 2);
    }
    .next-month {
      width: 30px;
      margin-right: 20px;
      @include pageIcon(left, 1);
    }
  }

  .weeks {
    display: flex;
    height: 35px;
    justify-content: space-between;
    // opacity: 0.5;
    border-bottom: 1px solid rgba($color: #fff, $alpha: 0.5);
    li {
      flex: 1;
    }
  }
  .day-box {
    display: flex;
    /* height: 400px; */
    flex-direction: column;
    padding: 16px 0 16px;
    ul {
      display: flex;
      justify-content: space-between;
      & + ul {
        margin-top: 5px;
      }
    }
    li {
      // width: 30px;
      height: 30px;
      line-height: 30px;
      // border-radius: 50%;
      flex: 1;
      justify-content: space-between;
      cursor: pointer;
      &:hover {
        // background: #ffffff;
        // color: pink;
        span {
          display: inline-block;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: #ffffff;
          color: #577ec7;
        }
      }
    }
  }
  .day_isSelect {
    // background: #ffffff;
    span {
      color: #577ec7;

      display: inline-block;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background: #ffffff;
    }
    // position: relative;
    // &::after{
    //   content:'';
    //   position:absolute;

    // }
  }
  .not__optional {
    opacity: 0.5;
    cursor: not-allowed !important ;
  }
}

// 弹框打开时
.autocomplete__open {
  .input-container {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 1px solid white;
  }

  .by-input__inner {
    &:focus {
      border-radius: 0px !important;
      border-color: #fff !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reception/checkPrice/components/CheckCalender.vue